import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import clsx from 'clsx';
    

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CContainer',
  props: {
        status: {
            type: String,
            default: "",
        }
    },
  setup(__props) {

const props = __props

    

    let statusBorderCss = "border-transparent"

    switch (props.status) {
        case "Active":
            statusBorderCss = "border-green-400"
            break;
        case "Paid":
            statusBorderCss = "border-green-400"
            break;
        case "Pending":
            statusBorderCss = "border-yellow-400"
            break;
        case "Past Due":
        case "Payment Failed":
            statusBorderCss = "border-red-400"
            break;
        case "Cancelled":
            statusBorderCss = "border-gray-400"
            break;
        default:
            break;
    }

    const classes = clsx(
        "rounded-lg shadow p-8 bg-white space-y-12 border",
        statusBorderCss
    )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})